import React, { ReactNode, Suspense } from 'react';
import SpinnerLoader from '../Common/SpinnerLoader';
interface LazyLoadProps {
  children: ReactNode;
}

export const LazyLoad: React.FC<LazyLoadProps> = (props) => {
  return <Suspense fallback={<SpinnerLoader />}>{props.children}</Suspense>;
};
